/* Per-lot reconciliation between invoice.lines[].cases (what the
   client/invoice document shows) and invoice.palletAllocations[].cases
   (the physical assignment — the ONLY source calcLotProfit/profitCalc.js
   uses for the shipment's real cases/profit). The two are edited in
   different places (product Lines table vs Pallet Allocations table)
   and nothing keeps them in sync automatically, so they can drift:
   e.g. a lot gets split across 2 PUs via allocations, but the
   line's own "cases" field never gets corrected down to match. Shared
   between InvoiceRegistry.js and SweetLeafPortal.js since both have
   their own copy of the same lines+palletAllocations save flow. */
export function computeLotBalances(lines, palletAllocations) {
  var linesByLot = {};
  (lines || []).forEach(function (l) {
    if (!l || !l.lot) return;
    linesByLot[l.lot] = (linesByLot[l.lot] || 0) + (parseInt(l.cases, 10) || 0);
  });
  var allocByLot = {};
  (palletAllocations || []).forEach(function (a) {
    if (!a || !a.lot) return;
    allocByLot[a.lot] = (allocByLot[a.lot] || 0) + (parseInt(a.cases, 10) || 0);
  });
  var lots = Array.from(new Set([].concat(Object.keys(linesByLot), Object.keys(allocByLot)))).sort();
  return lots.map(function (lot) {
    var linesCases = linesByLot[lot] || 0;
    var allocCases = allocByLot[lot] || 0;
    return { lot: lot, linesCases: linesCases, allocCases: allocCases, balanced: linesCases === allocCases };
  });
}

export function lotBalanceMismatches(lines, palletAllocations) {
  return computeLotBalances(lines, palletAllocations).filter(function (b) { return !b.balanced; });
}
